// eslint-disable-next-line max-len
import { PrintPlateReferencesDialog } from 'pages/CatalogPage/DH/SubcategorySection/SparePartsSection/PrintPlate/PrintPlateReferencesDialog';

export default PrintPlateReferencesDialog;
